import {_} from 'lodash';
import * as ko from "knockout";
import {IMessageData, ISyncField} from "../../../index";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {storeObservable} from "../../../util/sessionstore";
import {AvailableLanguages, ILanguage} from "../../../constants/Language";
import {IAvailableData, ITableOptions, TMode} from "./index";
import {Group} from "./group";
import {nsSystemfields} from "../nsSystemfields";
import {ErrorManager} from "../../../error/ErrorManager";
import tableHtml from './table.html?raw';

export const template = tableHtml;

interface IParams {
    availableData: IAvailableData
    groups: KnockoutObservableArray<Group>
}

export class Table {
    private readonly isMutable = nsSystemfields.isMutable

    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker()
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null)
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null)

    public readonly searchkey: KnockoutObservable<string>

    // navigation
    public readonly pagenr: KnockoutObservable<number> = ko.observable(0)
    private readonly pages = ko.pureComputed((): number => {
        const ret = this.totalresults() / this.resultsprpage()
        return Math.ceil(ret)
    })
    private readonly totalresults = ko.pureComputed(() => this.getList().length)
    private readonly resultsprpage: KnockoutObservable<number> = storeObservable("num.search.results");

    public readonly errorManager = new ErrorManager()

    private navigationParams = {
        pagenr: this.pagenr,
        pages: this.pages,
        resultsprpage: this.resultsprpage,
        totalresults: this.totalresults,
    }

    // sort
    private readonly asc: KnockoutObservable<boolean> = ko.observable(true)
    public readonly sortcol: KnockoutObservable<keyof ISyncField> = ko.observable('syncfieldid' as keyof ISyncField)
    private readonly modes: TMode[];
    private readonly isSortable: boolean;

    constructor(private availableData: IAvailableData, options: ITableOptions) {
        this.searchkey = options.searchkey ?? ko.observable('')
        this.isSortable = !!options.sortcol
        this.sortcol(options.sortcol ?? 'syncfieldid')
        this.modes = options.modes
        if (this.searchkey) {
            this.kosub.subscribe(this.searchkey, () => this.pagenr(0))
        }
    }

    public groups: KnockoutComputed<Group[]> = ko.pureComputed(() => this.availableData?.groups?.().filter((g: Group) => this.modes.includes(g.mode())))

    private getList = ko.pureComputed((): Group[] => {
        let ret = this.filter()
        ret = _.sortBy(ret, (g: Group) => g.getSortValue())
        return this.asc()
            ? ret
            : ret.reverse()
    })

    private getPage = ko.pureComputed((): Group[] => {
        const from = this.pagenr() * this.resultsprpage()
        const to = from + this.resultsprpage()
        return this.getList().slice(from, to)
    })

    private getLanguage(id: number): ILanguage {
        return AvailableLanguages.find(o => o.id == id)!
    }

    filter(): Group[] {
        const searchkey = String(this.searchkey?.() ?? '');
        if (searchkey) {
            return this.groups().filter((g: Group) => g.filterSearchKey(searchkey.toLowerCase()))
        }
        return this.groups()
    }

    numChanges(): number {
        return this.groups?.().filter(g => g.isChanged()).length
    }

    isChanged(): boolean {
        return !!this.groups?.().find(g => g.isChanged());
    }

    private getDef = nsSystemfields.getDef

    dispose() {
        this.kosub.unsuscribeAll()
    }

}